import throttle from 'lodash.throttle';
import { initializeCart } from '../updateCart';
import { isDown } from '../utils/mediaQuery';
import LineClamp from '../utils/lineClamp';
import QuickView from '../components/quickView';

const shopCurrency = document.querySelector('body').dataset.currency;

export default class Pdp {
  constructor() {
    this.body = document.querySelector('body');
    this.mainNavbar = document.getElementById('shopify-section-menu-bar');
    this.pdpStickyNav = document.getElementById('pdp-sticky-nav');

    this.heroSelectedImg = document.querySelectorAll('#pdp-hero .hero-selected-img');
    this.heroThumbnails = document.querySelectorAll('#pdp-hero .hero-carousel img');
    this.mobileVariantSelectors = document.querySelectorAll('.mobile-variant-selector');
    this.sizeVariantSelector = document.querySelector('#pdp-hero .variant-selector.size .dropdown');
    this.variantOptions = document.querySelectorAll(
      '#pdp-hero .variant-selector .options-container div'
    );
    if (document.getElementById('order-submit')) {
      this.heroSubmitOrderBtn = document.getElementById('order-submit');
    }
    this.navSubmitOrderBtn = document.querySelector('#pdp-sticky-nav button');

    this.form = document.querySelector('form.shopify-product-form');
    this.input_purchase_type = this.form.querySelector('[name="purchase_type"]');
    this.input_shipping_interval_unit_type = this.form.querySelector(
      '#shipping_interval_unit_type'
    );
    this.input_shipping_interval_frequency = this.form.querySelector(
      '#shipping_interval_frequency'
    );
    this.ingredientViewAll = document.querySelector('button.all-ingredients');
    this.ingredientModal = document.querySelector('.ingredient-modal');

    if (document.querySelector('#pdp-ingredient')) {
      this.ingredientArticle = document.querySelector('#pdp-ingredient .article');
      this.ingredientCarousel = document.querySelector(
        '#pdp-ingredient .img-carousel .main-carousel'
      );
      this.ingredientPrevBtn = document.querySelector('#pdp-ingredient .img-carousel .prev');
      this.ingredientNextBtn = document.querySelector('#pdp-ingredient .img-carousel .next');
    }

    this.youtubeLink = document.querySelector('.steps-img--container input');
    this.youtubePlayer = document.querySelector('.steps-img--container iframe');

    this.routineCarousel = document.querySelector('#pdp-routine .routine-carousel');
    this.routinePrevBtn = document.querySelector('#pdp-routine .carousel-container .prev');
    this.routineNextBtn = document.querySelector('#pdp-routine .carousel-container .next');
    this.routineAddToCartBtn = document.querySelector('#pdp-routine .routine-copy .add-to-cart');
    this.routineProducts = document.querySelectorAll('#pdp-routine .product-item');
    this.yoptoReviews = document.querySelectorAll('#pdp-review .yotpo-main-widget');
    this.routineQuickViewBtn = document.querySelectorAll(
      '#pdp-routine .product-item .thumbnail button'
    );

    this.modals = document.querySelectorAll('.modal');
    this.modalContent = document.querySelectorAll('.modal .content');
    this.closeModalBtn = document.querySelectorAll('.modal .content .close-modal');

    if (document.querySelector('#pdp-wyg')) {
      this.wygTabButton = document.querySelectorAll('#pdp-wyg .tabs li button');
      this.wygTabContainer = document.querySelector('#pdp-wyg .yes-no--container');
      this.wygYesContainer = this.wygTabContainer.querySelector('.main-carousel.yes');
      this.wygNoContainer = this.wygTabContainer.querySelector('.main-carousel.no');
    }

    if (document.querySelector('#pdp-ingredient')) {
      this.ingredientModuleY =
        window.pageYOffset + document.getElementById('pdp-ingredient').getBoundingClientRect().top;
    }
    this.lastScroll = window.pageYOffset;

    // --------------- Initialize carousels --------------- //
    this.flktyIngredient;
    if (this.ingredientCarousel) {
      this.flktyIngredient = new Flickity(this.ingredientCarousel, {
        contain: true,
        lazyLoad: true,
        prevNextButtons: false,
        on: {
          ready: () => {
            setTimeout(() => {
              const slides = this.flktyIngredient.slides.length;
              checkInvert(this.ingredientCarousel, 0);

              if (slides < 2) {
                const carouselContainer = document.querySelector('#pdp-ingredient .img-carousel');
                carouselContainer.classList.add('no-indicators');
              } else {
                const pageLabel = this.ingredientCarousel.querySelector('.flickity-page-dots');
                pageLabel.dataset.index = `1/${slides}`;
              }
            }, 0);
          }
        }
      });
    }

    if (document.querySelector('#pdp-routine')) {
      this.flktyRoutine = new Flickity(this.routineCarousel, {
        contain: true,
        groupCells: '100%',
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false,
        on: {
          ready: () => {
            setTimeout(() => {
              if (this.flktyRoutine.slides.length < 2) {
                this.routineNextBtn.classList.add('hide');
                this.routinePrevBtn.classList.add('hide');
              }
            }, 0);
          }
        }
      });
    }

    if (document.querySelector('#pdp-wyg')) {
      this.flktyWYG = new Flickity(this.wygTabContainer, {
        draggable: false,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true
      });
    }

    // Initialize youtube player
    if (this.youtubeLink) {
      // Strip video ID from youtube url
      const regex = /[a-zA-Z0-9]{8,}/;
      const videoId = youtubeLink.value.match(regex)[0];

      this.youtubePlayer.src = `https://www.youtube.com/embed/${videoId}`;
    }

    // Initialize routine reviews
    this.fetchRoutineReviews();

    // --------------- Attach event listeners --------------- //
    this.fetchMainReviews();
    window.addEventListener(
      'scroll',
      throttle(() => {
        this.switchNavbar();
      }, 400)
    );
    this.body.addEventListener('click', () => {
      const sizeDropdown = document.querySelector('.variant-selector.size .options-container');
      if (sizeDropdown) {
        sizeDropdown.classList.remove('show');
      }
    });

    // Popup modal
    this.modals.forEach((modal) => {
      modal.addEventListener('click', (e) => {
        this.closeModal(e.target);
      });
    });

    this.closeModalBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
        let rootEl = e.target;

        // Find the root modal
        while (!rootEl.classList.contains('modal')) {
          rootEl = rootEl.parentElement;
        }

        this.closeModal(rootEl);
      });
    });

    this.modalContent.forEach((content) => {
      content.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    // Hero section
    const lineClamp = new LineClamp('.detail-line-clamp');
    this.heroSelectedImg.forEach((img) => {
      img.addEventListener('load', this.resetAnimation.bind(this));
    });
    this.heroThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', this.swapHeroImage.bind(this));
    });
    if (this.mobileVariantSelectors) {
      this.mobileVariantSelectors.forEach((selector) => {
        selector.addEventListener('click', this.toggleMobileVariantSelector.bind(this));
      });
    }
    if (this.sizeVariantSelector) {
      this.sizeVariantSelector.addEventListener('click', this.toggleSizeVariantSelector.bind(this));
    }
    if (this.variantOptions) {
      this.variantOptions.forEach((option) => {
        option.addEventListener('click', this.changeVariant.bind(this));
      });
    }
    if (document.getElementById('order-submit')) {
      this.heroSubmitOrderBtn.addEventListener('click', this.submitOrder.bind(this));
    }
    this.navSubmitOrderBtn.addEventListener('click', this.submitOrder.bind(this));

    // Ingredient section
    if (this.ingredientViewAll) {
      this.ingredientViewAll.addEventListener('click', () => {
        this.ingredientModal.style.display = 'flex';
      });
    }
    if (this.ingredientCarousel) {
      this.flktyIngredient.on('change', (index) => {
        // Change arrow style based on slide number
        if (index === 0) {
          this.ingredientPrevBtn.classList.add('disabled');
        } else {
          this.ingredientPrevBtn.classList.remove('disabled');
        }

        if (index === this.flktyIngredient.slides.length - 1) {
          this.ingredientNextBtn.classList.add('disabled');
        } else {
          this.ingredientNextBtn.classList.remove('disabled');
        }

        // Change caption
        const slides = this.flktyIngredient.slides.length;
        const cellEl = this.ingredientCarousel.querySelectorAll('.carousel-cell')[index];
        const captionEl = document.querySelector('#pdp-ingredient .img-carousel .caption');

        this.ingredientCarousel.querySelector('.flickity-page-dots').dataset.index = `${
          index + 1
        }/${slides}`;
        captionEl.querySelector('h3').innerText = cellEl.dataset.name;
        const location = captionEl.querySelector('h6');
        if (location) captionEl.querySelector('h6').innerText = cellEl.dataset.location;
        captionEl.querySelector('p').innerText = cellEl.dataset.caption;

        checkInvert(this.ingredientCarousel, index);
      });

      this.ingredientPrevBtn.addEventListener('click', () => {
        this.flktyIngredient.previous();
      });

      this.ingredientNextBtn.addEventListener('click', () => {
        this.flktyIngredient.next();
      });
    }

    const checkInvert = (carousel, index) => {
      const cellEl = carousel.querySelectorAll('.carousel-cell')[index];
      // Invert color
      if (cellEl.classList.contains('invert')) {
        document.querySelector('#pdp-ingredient .img-carousel').classList.add('invert');
      } else {
        document.querySelector('#pdp-ingredient .img-carousel').classList.remove('invert');
      }
    };

    // Routine section
    const quickView = new QuickView('#pdp-routine .modal');
    if (this.routineAddToCartBtn) {
      this.routineAddToCartBtn.addEventListener('click', this.addAllToCart.bind(this));
    }

    this.routineQuickViewBtn.forEach((product) => {
      product.addEventListener('click', this.openRoutineModal.bind(this));
    });

    if (document.querySelector('#pdp-routine')) {
      this.flktyRoutine.on('change', (index) => {
        // Change arrow style based on slide number
        if (index === 0) {
          this.routinePrevBtn.classList.add('disabled');
        } else {
          this.routinePrevBtn.classList.remove('disabled');
        }

        if (index === this.flktyRoutine.slides.length - 1) {
          this.routineNextBtn.classList.add('disabled');
        } else {
          this.routineNextBtn.classList.remove('disabled');
        }
      });
    }

    if (document.querySelector('#pdp-routine')) {
      this.routinePrevBtn.addEventListener('click', () => {
        this.flktyRoutine.previous();
      });

      this.routineNextBtn.addEventListener('click', () => {
        this.flktyRoutine.next();
      });
    }

    // What you get section
    if (typeof this.wygTabButton !== 'undefined') {
      this.wygTabButton.forEach((tab) => {
        tab.addEventListener('click', this.switchTab.bind(this));
      });
    }
    this.selectedVariant = '';
    this.productName = '';
  }

  // --------------- Event handlers --------------- //

  /**
   * Fetch bottomline product reviews using Yotpo API
   * and render stars if available
   */
  fetchRoutineReviews() {
    this.routineProducts.forEach((product) => {
      const id = product.dataset.productid;

      fetch(`https://api.yotpo.com/products/${yotpoKey}/${id}/bottomline`)
        .then((res) => {
          if (res.ok) return res.json();
          else throw Error(`Request rejected with status ${res.status}`);
        })
        .then((res) => {
          if (res.hasOwnProperty('response')) {
            const { average_score, total_reviews } = res.response.bottomline;
            const reviewEl = product.querySelector('.product-item--review');
            reviewEl.classList.remove('empty');

            reviewEl.innerHTML = `
              <div class="star">
                <span>${average_score}</span>
                <div class="yotpo bottomline">
                  <div class="yotpo-bottomline pull-left star-clickable">
                    <span class="yotpo-stars">
                      <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="review-count">${total_reviews} Review${total_reviews > 1 ? 's' : ''}</div>
            `;
          }
        })
        .then(yotpo.refreshWidgets)
        .catch((err) => console.log);
    });
  }

  fetchMainReviews() {
    if (this.yoptoReviews.length > 0) {
      var product = this.yoptoReviews[0];
      var id = product.dataset.productId;
      fetch("https://api.yotpo.com/products/".concat(yotpoKey, "/").concat(id, "/bottomline")).then(function (res) {
        if (res.ok) return res.json();else throw Error("Request rejected with status ".concat(res.status));
      }).then(function (res) {
        if (res.hasOwnProperty('response')) {
          var _res$response$bottoml = res.response.bottomline,
              average_score = _res$response$bottoml.average_score,
              total_reviews = _res$response$bottoml.total_reviews;
          const reviewEl = document.createElement('div');
          reviewEl.classList.add('product-item--review');
          reviewEl.innerHTML = "\n<div class=\"star\">\n<span>".concat(average_score, "/5 Stars</span>\n <span class=\"review-count\">(").concat(total_reviews, " Review").concat(total_reviews > 1 ? 's' : '', ")</span>\n</div>");
          const currentDiv = document.getElementById("reviews-mark");
          currentDiv.appendChild(reviewEl);
        }
      }).then(yotpo.refreshWidgets).catch(function (err) {
        return console.log;
      });
    }
  }

  /**
   * Switch sticky navbar into pdp navbar on scroll direction
   */
  switchNavbar(e) {
    if (isDown('lg')) return;

    const currentScroll = window.pageYOffset;

    if (!this.body.classList.contains('menu-open')) {
      if (currentScroll > this.lastScroll && currentScroll > this.ingredientModuleY) {
        // down
        this.pdpStickyNav.classList.add('scroll-down');
        this.pdpStickyNav.classList.remove('scroll-up');
      } else if (currentScroll < this.lastScroll) {
        // up
        this.pdpStickyNav.classList.add('scroll-up');
        this.pdpStickyNav.classList.remove('scroll-down');
      }
    }

    this.lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  }

  /**
   * Close popup modal
   */
  closeModal(el) {
    el.classList.add('out');

    setTimeout(() => {
      el.style.display = 'none';
      el.classList.remove('out');
    }, 250);
  }

  /**
   * Reset animation
   */
  resetAnimation(e) {
    const el = e.target;

    el.style.animation = 'none';
    el.offsetHeight;
    el.style.animation = null;
  }

  /**
   * Switch selected image on hero module upon clicking thumbnail
   */
  swapHeroImage(e) {
    let selectedImg = e.target;
    const imgSrc = e.target.dataset.src;
    const imgIndex = e.target.dataset.index;

    while (!selectedImg.classList.contains('hero-carousel')) {
      selectedImg = selectedImg.parentElement;
    }

    selectedImg = selectedImg.previousElementSibling;
    selectedImg.src = imgSrc;
    selectedImg.alt = selectedImg.dataset.alt + ' ' + imgIndex;
  }

  /**
   * Toggle mobile variant selector panel
   */
  toggleMobileVariantSelector(e) {
    let el = e.target;
    while (!el.classList.contains('mobile-variant-selector')) {
      el = el.parentElement;
    }

    const colorPanel = document.querySelector('.variant-selector.color');
    const colorSelector = document.querySelector('.mobile-variant-selector.color');
    const sizePanel = document.querySelector('.variant-selector.size');
    const sizeSelector = document.querySelector('.mobile-variant-selector.size');

    if (el.classList.contains('color')) {
      // Toggle color selector
      if (colorPanel && colorSelector) {
        colorPanel.classList.toggle('hide');
        colorSelector.classList.toggle('show');
      }
      // Toggle size selector
      if (sizePanel && sizeSelector) {
        sizePanel.classList.add('hide');
        sizeSelector.classList.remove('show');
      }
    } else if (el.classList.contains('size')) {
      // Toggle color selector
      if (colorPanel && colorSelector) {
        colorPanel.classList.add('hide');
        colorSelector.classList.remove('show');
      }
      // Toggle size selector
      if (sizePanel && sizeSelector) {
        sizePanel.classList.toggle('hide');
        sizeSelector.classList.toggle('show');
      }
    }
  }

  /**
   * Toggle size selector dropdown on desktop
   */
  toggleSizeVariantSelector(e) {
    e.stopPropagation();

    const el = document.querySelector('.variant-selector.size .options-container');
    el.classList.toggle('show');
  }

  /**
   * Handle click event upon changing variant
   */
  changeVariant(e) {
    let selectedColor = document.querySelector('#pdp-hero .variant-selector.color .selected');
    let selectedSize = document.querySelector('#pdp-hero .variant-selector.size .selected');

    if (selectedColor) {
      selectedColor = selectedColor.dataset.value
      this.selectedVariant = selectedColor;
    }

    if (selectedSize) {
      selectedSize = selectedSize.dataset.value
      this.selectedVariant = selectedSize;
    }

    let target = e.target;
    let parent = target;
    while (!parent.classList.contains('variant-selector')) {
      parent = parent.parentElement;
    }

    if (parent.classList.contains('color')) {
      selectedColor = target.dataset.value;
    } else if (parent.classList.contains('size')) {
      selectedSize = target.dataset.value;
    }

    const productUrl = '//' + location.host + location.pathname;
    const variants = document.querySelector('#prod-selected-id').options;
    const variantSize = variants.length;

    for (let i = 0; i < variantSize; i++) {
      if (selectedColor && !variants[i].text.includes(selectedColor)) {
        continue;
      }

      if (selectedSize && !variants[i].text.includes(selectedSize)) {
        continue;
      }

      location.href = productUrl + `?variant=${variants[i].value}`;
      break;
    }
  }

  /**
   * Handle add to cart button using Shopify Ajax API
   */
  submitOrder(e) {
    e.preventDefault();

    // Open QVC page if specified
    const href = e.target.dataset.href;
    if (href) {
      var newTab = window.open(href, '_blank');
      newTab.focus();
      return;
    }

    let variantId;
    const variants = document.querySelector('#prod-selected-id');
    const quantity = document.querySelector('input[name=quantity]');
    const variantOptions = variants.options;
    const selectedVariantIndex = variants.selectedIndex;
    const isSubscription = this.input_purchase_type.value === 'autodeliver';
    let properties;

    const custom_quantity = document.querySelector('.shopify-product-form input[name="quantity"]').value;

    // Check if subscription order
    if (isSubscription) {
      variantId = variantOptions[selectedVariantIndex].dataset.value;

      properties = {
        shipping_interval_frequency: this.input_shipping_interval_frequency.value,
        shipping_interval_unit_type: this.input_shipping_interval_unit_type.value
      };
    } else {
      variantId = variantOptions[selectedVariantIndex].value;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: quantity.value,
        id: variantId,
        properties
      })
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error(`Request rejected with status ${res.status}`);
      })
      .then((res) => {
        initializeCart();
        this.body.classList.add('cart-open');
        document.getElementById('shopify-section-cart').classList.add('show');

        var finalPrice = (res.final_price / 100.00).toFixed(2);

        snaptr('track','ADD_CART', {
          'currency': shopCurrency,
          'price': finalPrice
        });

      })
      .catch(console.log);
  }

  /**
   * Add all product on routine section using Shopify Ajax API
   */
  addAllToCart() {
    let items = [];

    this.routineProducts.forEach((product) => {
      const isAvailable = product.querySelector('.price').innerText !== 'Out of stock';
      const routineProductQty = product.dataset.qty

      if (isAvailable) {
        items.push({
          quantity: routineProductQty,
          id: parseInt(product.dataset.id)
        });

        snaptr('track','ADD_CART', {
          'currency': shopCurrency,
          'price': product.dataset.price
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error(`Request rejected with status ${res.status}`);
      })
      .then((res) => {
        initializeCart();
        this.body.classList.add('cart-open');
        document.getElementById('shopify-section-cart').classList.add('show');
      })
      .catch(console.log);
  }

  /**
   * Open product routine quickview modal
   */
  openRoutineModal(e) {
    e.preventDefault();

    let target = e.target;
    while (!target.classList.contains('product-item')) {
      target = target.parentElement;
    }

    const productId = target.dataset.productid;
    const routineModal = document.getElementById(`quick-view-${productId}`);
    const productName = routineModal.querySelector('.hero-desc--container h1').innerText;
    const selectedImg = routineModal.querySelector('.hero-selected-img');
    const heroEyebrow = selectedImg.dataset.heroEyebrow != '' ? ' ' + selectedImg.dataset.heroEyebrow : '';
    const variantTitle = (this.selectedVariant != undefined && this.selectedVariant != 'Default Title' && this.selectedVariant != '') ? ` ${this.selectedVariant}` : '';

    selectedImg.dataset.alt = `Korres${heroEyebrow}${variantTitle} ${productName}`;

    selectedImg.src = selectedImg.dataset.src;
    routineModal.style.display = 'flex';
  }

  /**
   * Handle what you get tab switching
   */
  switchTab(e) {
    const target = e.target;
    const index = target.dataset.index;
    const parent = target.parentElement;
    const sibling = parent.nextElementSibling || parent.previousElementSibling;

    this.flktyWYG.select(index);

    sibling.classList.remove('active');
    parent.classList.add('active');
  }
}
